import { components } from "@certn/api/generated-schemas/applicant-portal";

import { ArchivedCard } from "./ArchivedCard";
import { CancelledCard } from "./CancelledCard";
import { CompleteCard } from "./CompleteCard";
import { DeclinedCard } from "./DeclinedCard";
import { DisputeCard } from "./DisputeCard";
import { SubmittedCard } from "./SubmittedCard";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}

export function HistoryCard(props: Props) {
  const { caseInstance } = props;
  if (caseInstance.archived_on) {
    return <ArchivedCard caseInstance={caseInstance} />;
  }
  if (caseInstance.overall_status === "CANCELLED") {
    return <CancelledCard caseInstance={caseInstance} />;
  }
  if (caseInstance.overall_status === "APPLICANT_DECLINED") {
    return <DeclinedCard caseInstance={caseInstance} />;
  }

  if (caseInstance.overall_status === "COMPLETE") {
    return <CompleteCard caseInstance={caseInstance} />;
  }

  if (!caseInstance.logs || caseInstance.logs.length === 0) {
    return null;
  }

  const lastLog = caseInstance.logs[caseInstance.logs.length - 1];
  if (lastLog.additional_data?.event === "CHECK_DISPUTED") {
    return <DisputeCard caseInstance={caseInstance} />;
  }

  return <SubmittedCard caseInstance={caseInstance} />;
}
